import {
  CANARY_HOSTS,
  DEV_HOSTS,
  LOCAL_HOSTS,
} from '@ads/front-core/utils/isDev'

export const getAdsUrl = (): string => {
  if (typeof window === 'undefined') {
    return
  }
  const hostname = window.document.location.hostname

  if (LOCAL_HOSTS.includes(hostname)) {
    return 'http://127.0.0.1:3100'
  }

  if (DEV_HOSTS.includes(hostname)) {
    return 'https://adswppl-dev.grupawp.pl'
  }

  if (CANARY_HOSTS.includes(hostname)) {
    return 'https://ads-frontend-canary-app-http.kube.dev.dcwp.pl'
  }

  return 'https://ads.wp.pl'
}
